<template>
  <div class="uk-margin uk-flex uk-flex-around">
    <span v-if="disableBackButton !== false" />
    <button
      v-if="disableBackButton !== true"
      class="uk-button btn-success"
      :disabled="disableBackButton"
      @click="backPage"
    >
      Atrás
    </button>
    <button
      class="uk-button"
      :disabled="!isComplete"
      @click="nextPage"
    >
      Continuar
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      disableBackButton: state => state.page === 0
    }),
    isComplete () {
      return this.$helperPlugin.isFormCompleted(this.data)
    }
  },

  methods: {
    nextPage () {
      this.$store.commit('nextPage')
      this.$windowPlugin.scrollToTop()
    },
    backPage () {
      this.$store.commit('backPage')
      this.$windowPlugin.scrollToTop()
    }
  }

}
</script>
<style scoped>
@media screen and (max-width: 689px){
  *{
    font-size: 10px;
  }
}
</style>
